import request from "@/utils/request";
// 首页banner列表
export function recommedBannerList(params) {
  return request({
    url: "/newsInformation/bannerList",
    method: "get",
    params,
  });
}
// 置顶新闻列表-列表
export function reportTopNewsList(params) {
  return request({
    url: "/newsInformation/topList",
    method: "get",
    params,
  });
}

// 专栏观点列表-列表
export function columnOpinionList(params) {
  return request({
    url: "/newsInformation/columnOpinionList",
    method: "get",
    params,
  });
}
// 新闻资讯各个类型-列表
export function newsTypeList(params) {
  return request({
    url: "/newsInformation/list",
    method: "get",
    params,
  });
}
// 新闻资讯分页列表（按类型，用于文章列表页）
export function newsPagesTypeList(params) {
  return request({
    url: "/newsInformation/pageList",
    method: "get",
    params,
  });
}

// 新闻资讯详情
export function newsNoticeDetail(params) {
  return request({
    url: "/newsInformation/detail",
    method: "get",
    params,
  });
}
